import { render, staticRenderFns } from "./SysPortalOrgForm.vue?vue&type=template&id=ab3778a0&"
import script from "./SysPortalOrgForm.vue?vue&type=script&lang=js&"
export * from "./SysPortalOrgForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab3778a0')) {
      api.createRecord('ab3778a0', component.options)
    } else {
      api.reload('ab3778a0', component.options)
    }
    module.hot.accept("./SysPortalOrgForm.vue?vue&type=template&id=ab3778a0&", function () {
      api.rerender('ab3778a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/portal/modules/SysPortalOrgForm.vue"
export default component.exports